import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { ISaveDeleteResponse } from 'src/app/Shared/interface';
import { IBatchFollowupsListModel, IBatchFollowUpData, IBatchFollowupInput, ISaveFollowUpList, IActiveUnitDetailsModel, IBatchTasksModel, IBatchTasksListInputModel, IBatchTasksListModel } from 'src/app/Shared/models/BatchFollowup';
import { FingerPrintService } from '../fingerPrint/fingerprint.service';
import {AppService} from '../app.service';

@Injectable({
    providedIn: 'root'
})

export class BatchService {
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                public fingerPrintService: FingerPrintService,
                private appService: AppService) { }

    private baseURL = this.appService.config.apiBaseUrl;

    getFollowupList(batchFollowupsListFilters: any): Observable<IBatchFollowupsListModel[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/BatchFollowup/GetFollowupList`;
        return this.http.post<IBatchFollowupsListModel[]>(url, batchFollowupsListFilters, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getFollowupData(batchFollowupData: IBatchFollowupInput): Observable<IBatchFollowUpData> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/BatchFollowup/GetFollowUpData`;
        return this.http.post<IBatchFollowUpData>(url, batchFollowupData, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getReprintData(reprintInput): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/BatchReprint/GetBatchReprintLetters`;
        return this.http.post<IBatchFollowUpData>(url, reprintInput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveFollowupList(SavebatchFollowupsList: any, id): Observable<ISaveDeleteResponse> {
        let options = {};
        if (this.fingerPrintService.isFingerPrintUsed) {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
        } else {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }

        let url = '';
        if (id === 0) {
            url = `${this.baseURL}/Prospects/CreateFollowUp`;
        } else {
            url = `${this.baseURL}/Prospects/UpdateFollowUp`;
        }

        return this.http.post<ISaveDeleteResponse>(url, SavebatchFollowupsList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getCallscript(dripid): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/BatchFollowup/GetCallerScriptDetails?dripActionId=${dripid}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    SaveBatchTask(saveModel: IBatchTasksModel, id): Observable<ISaveDeleteResponse> {
        let options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (id === 0) {
            url = `${this.baseURL}/BatchTasks/CreateTasks`;
        } else {
            url = `${this.baseURL}/BatchTasks/UpdateTasks`;
        }

        return this.http.post<ISaveDeleteResponse>(url, saveModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetBatchTaskList(batchTaskFilters: IBatchTasksListInputModel): Observable<IBatchTasksListModel[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/BatchTasks/GetBatchTaskList`;
        return this.http.post<IBatchTasksListModel[]>(url, batchTaskFilters, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetTasksById(id: number): Observable<IBatchTasksModel> {
        return this.http.get<any>(
            `${this.baseURL}/BatchTasks/GetTasksById?taskId=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const details = res.body as IBatchTasksModel;
                    return details;
                }),
                catchError(this.handleError)
            );
    }

    DeleteTasks(taskId: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<any>(`${this.baseURL}/BatchTasks/DeleteTasks?taskId=${taskId}`, options);
    }

    GetActiveUnitDetails(facilityId: number, type: number): Observable<IActiveUnitDetailsModel[]> {
        return this.http.get<any>(
            `${this.baseURL}/BatchTasks/GetActiveUnitDetails?facilityId=${facilityId}&type=${type}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const details = res.body as IActiveUnitDetailsModel[];
                    return details;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
